import React, { useState, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
//import "./styleFormik.css";
// import AuthHelperMethods from "./AuthHelperMethods";
import { Modal } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import { Td, Th, PrimaryTextBlue, Container } from "./styleCustom";
import {
  TableHeaderNoAdd,
  ModalHeaderBlue,
  ButtonOrange,
  ButtonColor,
} from "./formComponents";

import { MyContext, ListContext } from "./MyContext";
import { Check } from "./icons";

import { AddStaffForm } from "./clientForm";

import { active_options } from "./Constants2";
import { Active } from "./searchFilterReports";
import Auth from "./Auth";

const Staff = () => {
  const { listState, dispatch2 } = useContext(ListContext);
  const { mystate, dispatch } = useContext(MyContext);

  const [active, setActive] = useState(true);
  const [showAddStaff, setShowAddStaff] = useState(false);
  const [showbyList, setShowByList] = useState(false);
  const [initComplete, setInitComplete] = useState(false);
  // Local filter state for staff roles
  const [roleFilter, setRoleFilter] = useState("all");

  // Locally filtered staff list
  const filteredStaff = (listState.staff || []).filter((staff) => {
    if (roleFilter === "instructor") return staff.is_instructor;
    if (roleFilter === "volunteer") return staff.is_volunteer;
    if (roleFilter === "barnstaff") return staff.is_barnstaff;
    return true;
  });

  useEffect(
    () => {
      const fetchData = async () => {
        // let params = { is_active: active ? 1 : 0 };
        let params = { is_active: 1 };
        console.log("INITIAL");
        try {
          const result = await Auth.api("instructors/stafflist", "get", params);
          dispatch2(["STAFF_GET", result.data]);
          setInitComplete(true);
        } catch (error) {
          console.log("error");
        }
      };
      fetchData();
    },
    //eslint-disable-next-line
    [],
  );

  useEffect(
    () => {
      const fetchData = async () => {
        // let params = { is_active: active ? 1 : 0 };
        let params = { ...listState.filter };

        console.log("USEEFFECT STAFF");
        try {
          const result = await Auth.api("instructors/stafflist", "get", params);
          dispatch2(["STAFF_GET", result.data]);
          /* let accountHolder = listState.clients.find(
            (client) => client.id == result.data.person_id
          );*/
        } catch (error) {
          console.log("error");
        }
      };
      if (initComplete) fetchData();
    },
    //eslint-disable-next-line
    [listState.filter],
  );

  // useFetch("instructors/stafflist", "STAFF_GET", "dispatchlist", params);

  const StaffBox = (props) => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",

          height: 300,
          width: 250,
          background: "white",
          borderRadius: 10,
          alignItems: "center",
          justifyContent: "space-between",
          paddingBottom: 30,
          fontSize: 20,
          margin: 20,
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            flex: "1 1 100%",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              background: props.color || "lightgrey",
              minWidth: 250,
              minHeight: 60,
              marginBottom: 10,
            }}
          ></div>

          <div> {props.name}</div>
          <div>{"staff role"}</div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginBottom: 10,
          }}
        >
          <div>{props.email}</div>
          <div>{props.phone}</div>
        </div>
        <div>
          {" "}
          <Link to={`/admin/staffhome/${props.person_id}/details`}>
            <ButtonColor
              label={"view profile"}
              color={props.color || "lightgrey"}
            />
          </Link>
        </div>
      </div>
    );
  };

  const updateIsActive = async (staff) => {
    console.log(staff);
    let params = { ...listState.filter };
    // params.
    params.staffId = staff.instructor_id;
    params.accountHolderId = staff.person_id;
    params.whattodo = staff.is_active ? "inactivate" : "activate";
    try {
      dispatch({ type: "FETCH_INIT" });
      const result = await Auth.api(
        "people/updateIsActiveAccount",
        "post",
        params,
      );

      let params2 = { ...listState.filter };

      const result2 = await Auth.api("instructors/stafflist", "get", params2);
      dispatch2(["STAFF_GET", result2.data]);
      dispatch({ type: "FETCH_SUCCESS" });

      dispatch({
        type: "GET_INSTRUCTOR_OPTIONS",
        options: result.data.options,
      });
    } catch (e) {
      dispatch({ type: "FETCH_ERROR" });
    }
  };

  return (
    <>
      <Modal
        show={showAddStaff}
        size="lg"
        onHide={() => setShowAddStaff(false)}
      >
        <ModalHeaderBlue closeButton>
          <Modal.Title>{"Add New Staff Account"}</Modal.Title>
        </ModalHeaderBlue>
        <Modal.Body>
          <AddStaffForm onSave={() => setShowAddStaff(false)} />
        </Modal.Body>
      </Modal>
      <Container style={{ flexWrap: "wrap", flex: "1 1 100%" }}>
        <TableHeaderNoAdd title={"Staff"}>
          {" "}
          <ButtonOrange
            onClick={() => setShowAddStaff(true)}
            label={"Add New"}
          />
        </TableHeaderNoAdd>

        {/* Filter buttons for staff roles */}
        <div>
          <div
            style={{
              display: "flex",
              gap: 8,
              margin: "16px 0",
              marginRight: 15,
            }}
          >
            <button
              type="button"
              onClick={() => setRoleFilter("instructor")}
              style={{
                padding: "6px 16px",
                borderRadius: 5,
                border:
                  roleFilter === "instructor"
                    ? "2px solid #0099BC"
                    : "1px solid #ccc",
                background: roleFilter === "instructor" ? "#0099BC" : "#f7f7f7",
                color: roleFilter === "instructor" ? "#fff" : "#333",
                fontWeight: roleFilter === "instructor" ? 700 : 400,
                cursor: "pointer",
                outline: "none",
                transition: "all 0.15s",
                boxShadow:
                  roleFilter === "instructor" ? "0 2px 8px #ff980033" : "none",
              }}
            >
              Instructors/Trainers
            </button>
            <button
              type="button"
              onClick={() => setRoleFilter("volunteer")}
              style={{
                padding: "6px 16px",
                borderRadius: 5,
                border:
                  roleFilter === "volunteer"
                    ? "2px solid #0099BC"
                    : "1px solid #ccc",
                background: roleFilter === "volunteer" ? "#0099BC" : "#f7f7f7",
                color: roleFilter === "volunteer" ? "#fff" : "#333",
                fontWeight: roleFilter === "volunteer" ? 700 : 400,
                cursor: "pointer",
                outline: "none",
                transition: "all 0.15s",
                boxShadow:
                  roleFilter === "volunteer" ? "0 2px 8px #ff980033" : "none",
              }}
            >
              Volunteers
            </button>
            <button
              type="button"
              onClick={() => setRoleFilter("barnstaff")}
              style={{
                padding: "6px 16px",
                borderRadius: 5,
                border:
                  roleFilter === "barnstaff"
                    ? "2px solid #0099BC"
                    : "1px solid #ccc",
                background: roleFilter === "barnstaff" ? "#0099BC" : "#f7f7f7",
                color: roleFilter === "barnstaff" ? "#fff" : "#333",
                fontWeight: roleFilter === "barnstaff" ? 700 : 400,
                cursor: "pointer",
                outline: "none",
                transition: "all 0.15s",
                boxShadow:
                  roleFilter === "barnstaff" ? "0 2px 8px #ff980033" : "none",
              }}
            >
              Barn Staff
            </button>
            <button
              type="button"
              onClick={() => setRoleFilter("all")}
              style={{
                padding: "6px 16px",
                borderRadius: 5,
                border:
                  roleFilter === "all" ? "2px solid #0099BC" : "1px solid #ccc",
                background: roleFilter === "all" ? "#0099BC" : "#f7f7f7",
                color: roleFilter === "all" ? "#fff" : "#333",
                fontWeight: roleFilter === "all" ? 700 : 400,
                cursor: "pointer",
                outline: "none",
                transition: "all 0.15s",
                boxShadow:
                  roleFilter === "all" ? "0 2px 8px #ff980033" : "none",
              }}
            >
              Show All
            </button>
          </div>
          <Active
            field={"is_active"}
            default={"1"}
            options={active_options}
          />{" "}
        </div>

        <table style={{ width: "100%" }}>
          <thead>
            <tr>
              <Th />
              <Th>{"name"}</Th>
              <Th>{"email"}</Th>
              <Th>{"phone"}</Th>
              <Th>{"availability"}</Th>
              <Th>{"general notes"}</Th>
              <Th>{"has login account"}</Th>
              <Th>{"actions"}</Th>
            </tr>
          </thead>

          <tbody>
            {filteredStaff &&
              filteredStaff.map((staff) => (
                <tr key={staff.instructor_id}>
                  <Td
                    style={{
                      background: staff.is_active
                        ? staff.color_code
                        : "lightgrey",
                    }}
                  ></Td>

                  <Td>
                    {" "}
                    <Link to={`/admin/staffhome/${staff.person_id}/details`}>
                      <PrimaryTextBlue
                        style={{ background: !staff.is_active && "lightgrey" }}
                      >
                        {" "}
                        {staff.name}
                      </PrimaryTextBlue>
                    </Link>
                  </Td>
                  <Td>{staff.contact_email}</Td>
                  <Td>{staff.contact_mobile}</Td>

                  <Td>{staff.availability}</Td>
                  <Td>{staff.general_notes}</Td>
                  <Td>{staff.user_id && <Check />}</Td>

                  <Td
                    onClick={() => updateIsActive(staff)}
                    style={{ color: "red", cursor: "pointer" }}
                  >{`${staff.is_active ? "inactivate" : "activate"}`}</Td>
                </tr>
              ))}
          </tbody>
        </table>
      </Container>
    </>
  );
};

export default Staff;
